import { Grid } from '@design-systems/canvas-ui'
import TeamsTabs from '../TeamsTabs'
import TeamsListHeader from './TeamsListHeader'
import TeamsListBody from './TeamsListBody'
import { CoreSortAndFilterProvider } from '@plm-core/sort-and-filter'
import { PaginationProvider } from '@plm-core/utils'

const TeamsList = () => {
  return (
    <Grid.Container direction="column">
      <Grid.Item>
        <TeamsListHeader />
      </Grid.Item>
      <Grid.Item>
        <TeamsTabs />
      </Grid.Item>
      <Grid.Item>
        <CoreSortAndFilterProvider cacheKey="plm-teams-list">
          <PaginationProvider>
            <TeamsListBody />
          </PaginationProvider>
        </CoreSortAndFilterProvider>
      </Grid.Item>
    </Grid.Container>
  )
}

export default TeamsList
